import { useState } from 'react'
import styled from 'styled-components'

import StepSwiper from '@/features/home/components/MainStepSwiper'
import TabButtonGroup from '@/shared/components/ui/TabButton'
import useMediaQuery from '@/shared/hooks/useMediaQuery'
import { Nanum_b_size, Nanum_eb_size, Nanum_rb_size } from '@/styles/font/NanumSquare'
import { mediaMobile, mediaTablet } from '@/styles/mediaQuery'

const MainStepSwiperSection = () => {
  const { isMobile } = useMediaQuery()
  const [selectedIdx, setSelectedIdx] = useState(0)

  return (
    <Section>
      <SectionHeading>
        <HeadingTitle>휴대폰분실보호 서비스</HeadingTitle>
        <HeadingDesc>어떻게 이용하나요?</HeadingDesc>
      </SectionHeading>
      <TabButtonGroup
        tabs={
          isMobile
            ? ['가입방법', '분실폰 찾기']
            : ['분실 전에 미리 가입하고 싶어요!', '분실한 휴대폰을 찾고 싶어요! (가입자)']
        }
        activeIndex={selectedIdx}
        onChange={setSelectedIdx}
        className="home-tab"
      />
      <StepSwiper selectedIdx={selectedIdx} />
    </Section>
  )
}

export default MainStepSwiperSection

const Section = styled.section`
  padding: 124px 0 184px;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  background-color: var(--gray-fb);

  ${mediaTablet} {
    width: 100%;
    position: static;
    left: auto;
    margin-left: 0;
    margin-right: 0;
    background-color: var(--white);
    padding: 72px 0;
  }

  ${mediaMobile} {
    padding-left: 24px;
    padding-right: 24px;
  }
`

const SectionHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;

  ${mediaTablet} {
    text-align: left;
  }
`
const HeadingTitle = styled.h4`
  color: var(--green);
  ${Nanum_b_size(24)}
  font-weight: 500;
  letter-spacing: -0.7px;

  ${mediaTablet} {
    ${Nanum_rb_size(14)}
    font-weight: 800;
  }
`
const HeadingDesc = styled.p`
  letter-spacing: -2px;
  ${Nanum_eb_size(64)}

  ${mediaTablet} {
    ${Nanum_rb_size(26)}
    font-weight: 800;
  }
`
